import { useTranslation } from 'react-i18next';

export const PhoneNumberSkeleton = () => {
  const { t } = useTranslation();
  return (
    <div data-testid='dynamic-input-field'>
      <div className='flex flex-row items-center mb-2'>
        <label className='text-primary text-body-xs' htmlFor='financeNotifications.phone'>
          {t('companySettings:phoneLabel')}
        </label>
      </div>
      <div className='flex gap-2'>
        <div className='w-20'>
          <div className='w-full h-12 bg-tertiary rounded-sm animate-pulse' />
        </div>
        <div className='grow'>
          <div className='w-full h-12 bg-tertiary rounded-sm animate-pulse' />
        </div>
      </div>
    </div>
  );
};
